import axios from "./axiosInstance";

export const fetchAllShipments = async (page, perPage, filter) => {
  let response = { data: null, error: null };
  try {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page);
    if (perPage) queryParams.append("perPage", perPage);
    if (filter) queryParams.append("name", filter);

    const res = await axios.get(
      `get-all-shipments/all?${queryParams.toString()}`,
    );

    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error };
  }
  return response;
};

export const assignDriver = async (shipment, pickupDriver, deliveryDriver) => {
  let response = { data: null, error: null };

  // Prepare data payload only for selected drivers
  let data = {};
  if (pickupDriver) data.pickup_driver = parseInt(pickupDriver);
  if (deliveryDriver) data.delivery_driver = parseInt(deliveryDriver);

  if (Object.keys(data).length === 0) return response; // No drivers selected, skip API call

  try {
    const res = await axios.post(`custom-shipment/update/${shipment}`, data);
    response = { ...response, data: res.data };
  } catch (error) {
    response = {
      ...response,
      error: error.response?.data?.message || "API request failed",
    };
  }

  return response;
};

export const arrangePickup = async (companyId, shipmentId, data) => {
  let response = { data: null, error: null };

  try {
    const res = await axios.post(
      `create-pickup/${companyId}/${shipmentId}`,
      data,
    );
    response = { ...response, data: res.data };
    // console.log(res);
  } catch (error) {
    response = { ...response, error: error.response.data.message };
  }
  return response;
};

export const deleteInternationalDocument = async (shipment_id, document_id) => {
  let response = { data: null, error: null };

  try {
    const res = await axios.delete(
      `international/shipments/${shipment_id}/documents/${document_id}`,
    );
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error.response.data.message };
  }
  return response;
};

export const uploadInternationalDocument = async (shipmentId, data) => {
  let response = { data: null, error: null };

  try {
    const res = await axios.post(
      `international/shipments/${shipmentId}/documents`,
      data,
    );
    response = { ...response, data: res.data };
    // console.log(res);
  } catch (error) {
    response = { ...response, error: error.response.data.message };
  }
  return response;
};
